/* eslint-disable no-console */
<template>
  <div>
    <div
      class="flexible-content"
      v-if="currentPage != 'Login' && currentPage != 'LoginTeacher'"
    >
      <!--Navbar Admin-->
      <mdb-navbar
        v-if="
          currentPage != 'Login' && currentPage != 'LoginTeacher' && fastRole == 'ADMIN'
        "
        class="flexible-navbar color-main"
        dark
        position="top"
        scrolling
      >
        <span class="white-text font-weight-bold pl-3" target="_blank"
          >Welcome, Admin</span
        >
        <mdb-navbar-toggler>
          <mdb-navbar-nav right class="white-text text-white">
            <router-link to="/dashboard" @click.native="activeItem = 1">
              <mdb-nav-item waves-fixed class="d-block d-md-none white-text text-white"
                ><i class="fas fa-tachometer-alt mr-2"></i> Dashboard</mdb-nav-item
              >
            </router-link>
            <button @click="logout()" class="btn btn-danger btn-sm">
              <i class="fas fa-sign-out-alt mr-2"></i>Logout
            </button>
          </mdb-navbar-nav>
        </mdb-navbar-toggler>
      </mdb-navbar>
      <!--/.Navbar-->
      <!-- Sidebar Admin-->
      <div
        v-if="
          currentPage != 'Login' && currentPage != 'LoginTeacher' && fastRole == 'ADMIN'
        "
        class="sidebar-fixed position-fixed bg-dark white-text text-center scrollable-element"
      >
        <div class="logo-div py-5 font-weight-bold">
          <a class="logo-wrapper">
            <!-- <img alt="" class="img-fluid" width="100px" src="./assets/logo-mdb-vue-small.png" />-->
          </a>
        </div>

        <div class="link-div black-text">
          <router-link to="/dashboard" @click.native="activeItem = 1">
            <p class="nav-links">
              <i class="fas fa-tachometer-alt float-left"></i>Dashboard<i
                class="fas fa-caret-right float-right"
              ></i>
            </p>
          </router-link>
          
          <p class="nav-links">
            <mdb-dropdown end class="w-100">
              <mdb-dropdown-toggle slot="toggle" class="color-main"
                ><i class="fas fa-edit float-left mr-2"></i> Manage Art</mdb-dropdown-toggle
              >
              <mdb-dropdown-menu class="white">
                <router-link
                  :to="{
                    name: 'ArtVideos',
                  }"
                >
                  <mdb-dropdown-item class="black-text">View Art Videos</mdb-dropdown-item>
                </router-link>
                <router-link
                  :to="{
                    name: 'AddArtVideo',
                  }"
                >
                  <mdb-dropdown-item class="black-text">Add Art Video </mdb-dropdown-item>
                </router-link>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </p>

          <p class="nav-links pointer" role="button" type="button" @click="logout()">
            <i class="fas fa-sign-out-alt float-left"></i>Logout<i
              class="fas fa-caret-right float-right"
            ></i>
          </p>
        </div>
      </div>
      <!-- /Sidebar  -->

      <main>
        <div class="mt-5 p-5">
          <router-view></router-view>
        </div>
        <ftr color="color-main" class="text-center font-small darken-2">
          <p class="footer-copyright mb-0 py-3 text-center">
            &copy; {{ new Date().getFullYear() }} Copyright:
            <a> FAST MINDS </a>
          </p>
        </ftr>
      </main>
    </div>
    <div v-if="currentPage == 'Login' || currentPage == 'LoginTeacher'">
      <router-view></router-view>
      <div></div>
    </div>
  </div>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbNavItem,
  mdbFooter,
  waves,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
} from "mdbvue";

export default {
  name: "AdminTemplate",
  components: {
    mdbNavbar,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
    ftr: mdbFooter,
  },
  data() {
    return {
      activeItem: 1,
      currentPage: this.$router.currentRoute.name,
      fastRole: localStorage.getItem("fastRole"),
      teacherName: localStorage.getItem("teacherName"),
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("fastAdminToken");
      localStorage.removeItem("fastTeacherToken");
      localStorage.removeItem("fastTeacherId");
      localStorage.clear();
      if (this.fastRole == "TEACHER") {
        window.location.href = "/teacher-login";
      } else {
        window.location.href = "/login";
      }
    },
  },

  beforeMount() {
    this.activeItem = this.$route.matched[0].props.default.page;
  },
  mounted() {
    this.teacherName = localStorage.getItem("teacherName");
  },

  mixins: [waves],
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

.navbar-light .navbar-brand {
  margin-left: 15px;
  color: #2196f3 !important;
  font-weight: bolder;
}
</style>

<style scoped>
main {
  background-color: #ededee;
}

.scrollable-element {
  scrollbar-color: dark !important;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #262832;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #000;
}

.flexible-content {
  transition: padding-left 0.3s;
  padding-left: 250px;
}

.logo-div,
.my-drop-down {
  background: #262832;
}

.link-div {
  background: #292b35;
}

.flexible-navbar {
  transition: padding-left 0.5s;
  padding-left: 250px;
}

.sidebar-fixed {
  left: 0;
  top: 0;
  height: 100vh;
  width: 250px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 1050;
  background-color: #fff;
  padding: 0;
  padding-top: 0;
}

.sidebar-fixed .logo-wrapper img {
  padding: 30px 10px;
}

.logo-wrapper {
  padding: 20px;
  text-align: center;
}

.sidebar-fixed .list-group-item {
  display: block !important;
  transition: background-color 0.3s;
}

.sidebar-fixed .list-group .active {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 5px;
}

p.nav-links {
  background-color: #292b35;
  color: #ccc;
  margin: 0;
  margin-bottom: 10px;
  padding: 10px;
  font-weight: 500;
  border-bottom: 0.5px solid #262832;
}
.pointer {
  cursor: pointer;
}
p.nav-links:hover,
.color-main,
.my-drop-down:hover {
  color: #fff;
  background-color: #262832;
}

mdb-accordion-item-head span {
  color: red;
}

@media (max-width: 1199.98px) {
  .sidebar-fixed {
    display: none;
  }

  .flexible-content {
    padding-left: 0;
  }

  .flexible-navbar {
    padding-left: 10px;
  }
}
</style>
